<template>
  <main class="mall_main mb-20">
    <header
      class="max-w-[82.75rem] mx-auto max-md:!block max-md:text-center px-4 sm:px-6 lg:px-8"
    >
      <h2 class="font-bold max-md:mb-3">콘텐츠 몰</h2>

      <!-- 검색 -->
      <div class="mall_search_wr gap-3">
        <!-- <div class="flex-1 bg-white text-sm px-3 py-1 rounded">
          <p>
            <b>1</b> 하나바이블 5과정 2학기 <span class="ml-3 text-xs">▲</span>
          </p>
        </div> -->
        <label
          class="max-md:max-w-[33%] flex items-center border-r border-neutral-400 pr-2 gap-1"
        >
          <select
            v-model="selectedCategoryId"
            class="w-full text-sm bg-transparent appearance-none"
          >
            <option value="">카테고리 전체</option>
            <option
              :value="category.categoryId"
              v-for="category in categoryList"
              :key="category.categoryId"
            >
              {{ category.categoryName }}
            </option>
          </select>
          <svg
            width="9"
            height="5"
            viewBox="0 0 9 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.592761 0.000606174C0.670711 0.000246611 0.74795 0.0150999 0.819944 0.0442945C0.891939 0.0734892 0.95724 0.116437 1.01202 0.170619L4.54799 3.62496L8.08396 0.193801C8.19546 0.123176 8.32801 0.0911665 8.46035 0.102903C8.5927 0.11464 8.71718 0.169443 8.81384 0.258529C8.9105 0.347615 8.97375 0.465824 8.99345 0.594211C9.01314 0.722599 8.98815 0.853729 8.92246 0.966584L4.96724 4.8305C4.856 4.93904 4.70521 5 4.54799 5C4.39077 5 4.23997 4.93904 4.12873 4.8305L0.173507 0.966585C0.0624046 0.857912 -1.2917e-07 0.710601 -1.42597e-07 0.55701C-1.56025e-07 0.403419 0.0624045 0.256107 0.173507 0.147435C0.287996 0.0464373 0.438666 -0.0063289 0.592761 0.000606174Z"
              fill="black"
            />
          </svg>
        </label>

        <label class="w-full flex items-center gap-2">
          <input
            v-model="searchQuery"
            type="text"
            placeholder="검색어를 입력하세요."
            @keyup.enter="handleSearch(1)"
          />

          <button type="button" @click="handleSearch(1)">
            <font-awesome-icon icon="fa-solid fa-magnifying-glass" />
          </button>
        </label>
      </div>
    </header>

    <!-- 카테고리 영역  @mouseleave="hideSubCategories"-->
    <div
      ref="shopTopMenuRef"
      class="shop_top_menu relative"
      @mouseleave="hideSubCategories"
    >
      <nav
        class="xl:min-w-[768px] p-0 overflow-auto max-w-[82.75rem] mx-auto md:gap-x-4 px-4 md:px-6 lg:px-8"
      >
        <router-link to="/mall" active-class="current" class="mr-2">
          <span class="mainNav">
            <svg
              width="24"
              height="22"
              viewBox="0 0 24 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.459 0.66053C12.3259 0.556774 12.162 0.500427 11.9933 0.500427C11.8245 0.500427 11.6606 0.556774 11.5275 0.66053L0.75 9.06428L1.68225 10.2433L3 9.21578V18.5C3.00079 18.8976 3.15908 19.2787 3.44022 19.5598C3.72135 19.8409 4.10242 19.9992 4.5 20H19.5C19.8976 19.9992 20.2787 19.8409 20.5598 19.5598C20.8409 19.2787 20.9992 18.8976 21 18.5V9.22253L22.3177 10.25L23.25 9.07103L12.459 0.66053ZM13.5 18.5H10.5V12.5H13.5V18.5ZM15 18.5V12.5C15 12.1022 14.842 11.7207 14.5607 11.4394C14.2794 11.1581 13.8978 11 13.5 11H10.5C10.1022 11 9.72064 11.1581 9.43934 11.4394C9.15804 11.7207 9 12.1022 9 12.5V18.5H4.5V8.04653L12 2.20403L19.5 8.05403V18.5H15Z"
                fill="currentColor"
              />
            </svg>
            홈
          </span>
        </router-link>

        <div v-for="category in categoryList" :key="category.categoryId">
          <!-- 메인 카테고리 -->
          <router-link
            :to="'/mall/' + category.categoryId"
            :class="{ current: category.categoryId == route.params.category }"
            @mouseover.stop="getSubCategories(category.categoryId)"
          >
            <span class="mainNav">
              <svg
                v-if="category.categoryId == '170'"
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.61538 19.3015V14.8462H2.53846C2.13044 14.8462 1.73912 14.6841 1.45061 14.3955C1.16209 14.107 1 13.7157 1 13.3077V2.53846C1 2.13044 1.16209 1.73912 1.45061 1.45061C1.73912 1.16209 2.13044 1 2.53846 1H19.4615C19.8696 1 20.2609 1.16209 20.5494 1.45061C20.8379 1.73912 21 2.13044 21 2.53846V13.3077C21 13.7157 20.8379 14.107 20.5494 14.3955C20.2609 14.6841 19.8696 14.8462 19.4615 14.8462H11L6.27231 19.5738C6.21852 19.6278 6.14992 19.6645 6.07522 19.6794C6.00053 19.6943 5.92308 19.6867 5.85272 19.6575C5.78236 19.6284 5.72224 19.579 5.67999 19.5156C5.63773 19.4522 5.61525 19.3777 5.61538 19.3015Z"
                  stroke="currentColor"
                />
                <path
                  d="M5.61536 10.2308H16.3846M5.61536 5.61542H16.3846"
                  stroke="currentColor"
                  stroke-linecap="round"
                />
              </svg>

              <svg
                v-else-if="category.categoryId == '136'"
                width="24"
                height="22"
                viewBox="0 0 24 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.25 8C8.25 7.80109 8.32902 7.61032 8.46967 7.46967C8.61032 7.32902 8.80109 7.25 9 7.25H16C16.1989 7.25 16.3897 7.32902 16.5303 7.46967C16.671 7.61032 16.75 7.80109 16.75 8C16.75 8.19891 16.671 8.38968 16.5303 8.53033C16.3897 8.67098 16.1989 8.75 16 8.75H9C8.80109 8.75 8.61032 8.67098 8.46967 8.53033C8.32902 8.38968 8.25 8.19891 8.25 8ZM9 10.25C8.80109 10.25 8.61032 10.329 8.46967 10.4697C8.32902 10.6103 8.25 10.8011 8.25 11C8.25 11.1989 8.32902 11.3897 8.46967 11.5303C8.61032 11.671 8.80109 11.75 9 11.75H14C14.1989 11.75 14.3897 11.671 14.5303 11.5303C14.671 11.3897 14.75 11.1989 14.75 11C14.75 10.8011 14.671 10.6103 14.5303 10.4697C14.3897 10.329 14.1989 10.25 14 10.25H9Z"
                  fill="currentColor"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.5 3.25C7.24022 3.25 6.03204 3.75045 5.14124 4.64124C4.25045 5.53204 3.75 6.74022 3.75 8V18C3.75 18.9946 4.14509 19.9484 4.84835 20.6517C5.55161 21.3549 6.50544 21.75 7.5 21.75H18.5C18.9641 21.75 19.4092 21.5656 19.7374 21.2374C20.0656 20.9092 20.25 20.4641 20.25 20V5C20.25 4.53587 20.0656 4.09075 19.7374 3.76256C19.4092 3.43437 18.9641 3.25 18.5 3.25H8.5ZM18.75 14.25V5C18.75 4.9337 18.7237 4.87011 18.6768 4.82322C18.6299 4.77634 18.5663 4.75 18.5 4.75H8.5C7.63805 4.75 6.8114 5.09241 6.2019 5.7019C5.59241 6.3114 5.25 7.13805 5.25 8V15C5.89843 14.5119 6.68838 14.2485 7.5 14.25H18.75ZM18.75 15.75H7.5C6.90326 15.75 6.33097 15.9871 5.90901 16.409C5.48705 16.831 5.25 17.4033 5.25 18C5.25 18.5967 5.48705 19.169 5.90901 19.591C6.33097 20.0129 6.90326 20.25 7.5 20.25H18.5C18.5663 20.25 18.6299 20.2237 18.6768 20.1768C18.7237 20.1299 18.75 20.0663 18.75 20V15.75Z"
                  fill="currentColor"
                />
              </svg>

              <svg
                v-else-if="category.categoryId == '137'"
                width="18"
                height="22"
                viewBox="0 0 18 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.25 15.988V3.265L17.25 1.75V13.528M5.3955 6.778L17.589 5.038M5.25 15.9955C5.25 16.5922 5.01295 17.1645 4.59099 17.5865C4.16903 18.0084 3.59674 18.2455 3 18.2455C2.40326 18.2455 1.83097 18.0084 1.40901 17.5865C0.987053 17.1645 0.75 16.5922 0.75 15.9955C0.75 15.3988 0.987053 14.8265 1.40901 14.4045C1.83097 13.9826 2.40326 13.7455 3 13.7455C3.59674 13.7455 4.16903 13.9826 4.59099 14.4045C5.01295 14.8265 5.25 15.3988 5.25 15.9955ZM17.25 13.672C17.25 14.2687 17.0129 14.841 16.591 15.263C16.169 15.6849 15.5967 15.922 15 15.922C14.4033 15.922 13.831 15.6849 13.409 15.263C12.9871 14.841 12.75 14.2687 12.75 13.672C12.75 13.0753 12.9871 12.503 13.409 12.081C13.831 11.6591 14.4033 11.422 15 11.422C15.5967 11.422 16.169 11.6591 16.591 12.081C17.0129 12.503 17.25 13.0753 17.25 13.672Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
              </svg>

              <svg
                v-else-if="category.categoryId == '138'"
                width="21"
                height="22"
                viewBox="0 0 21 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11 0.9375L20.75 5V12.25H19.25V6.71353L18.5 7.08853V15.7863L17.9925 15.9597L17.75 15.25C17.9925 15.9597 17.9926 15.9597 17.9925 15.9597L17.9884 15.9611L17.978 15.9646L17.9388 15.9778C17.9048 15.9893 17.855 16.0059 17.7912 16.0269C17.6637 16.0688 17.4796 16.1285 17.2518 16.2C16.7964 16.3428 16.1639 16.5334 15.4554 16.7242C14.0646 17.0988 12.2905 17.5 11 17.5C9.70945 17.5 7.93531 17.0988 6.54455 16.7242C5.83608 16.5334 5.20356 16.3428 4.74819 16.2C4.52031 16.1285 4.33628 16.0688 4.20871 16.0269C4.14491 16.0059 4.09519 15.9893 4.06113 15.9778L4.02196 15.9646L4.01154 15.9611L4.00759 15.9598C4.0075 15.9597 4.00742 15.9597 4.24997 15.25L4.00759 15.9598L3.49997 15.7863V7.08853L0.198853 5.43797L11 0.9375ZM4.99997 7.83853V14.7064C5.06103 14.7259 5.12687 14.7467 5.19709 14.7687C5.63845 14.9072 6.25074 15.0916 6.93464 15.2758C8.32863 15.6512 9.92949 16 11 16C12.0705 16 13.6713 15.6512 15.0653 15.2758C15.7492 15.0916 16.3615 14.9072 16.8028 14.7687C16.8731 14.7467 16.9389 14.7259 17 14.7064V7.83853L11 10.8385L4.99997 7.83853ZM18.1989 5.56203L11 2.5625L3.80109 5.56203L11 9.16147L18.1989 5.56203Z"
                  fill="currentColor"
                />
              </svg>

              <svg
                v-else
                width="24"
                height="20"
                viewBox="0 0 24 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.459 0.66053C12.3259 0.556774 12.162 0.500427 11.9933 0.500427C11.8245 0.500427 11.6606 0.556774 11.5275 0.66053L0.75 9.06428L1.68225 10.2433L3 9.21578V18.5C3.00079 18.8976 3.15908 19.2787 3.44022 19.5598C3.72135 19.8409 4.10242 19.9992 4.5 20H19.5C19.8976 19.9992 20.2787 19.8409 20.5598 19.5598C20.8409 19.2787 20.9992 18.8976 21 18.5V9.22253L22.3177 10.25L23.25 9.07103L12.459 0.66053ZM13.5 18.5H10.5V12.5H13.5V18.5ZM15 18.5V12.5C15 12.1022 14.842 11.7207 14.5607 11.4394C14.2794 11.1581 13.8978 11 13.5 11H10.5C10.1022 11 9.72064 11.1581 9.43934 11.4394C9.15804 11.7207 9 12.1022 9 12.5V18.5H4.5V8.04653L12 2.20403L19.5 8.05403V18.5H15Z"
                  fill="currentColor"
                />
              </svg>
              {{ category.categoryName }}
            </span>
          </router-link>

          <!-- 서브 카테고리 -->
          <div
            v-if="categoryList2.length > 0"
            @mouseleave="hideSubCategories"
            class="absolute z-10 w-full overflow-x-auto top-full left-0 bg-neutral-100 border-y border-neutral-300 p-3"
          >
            <div class="max-w-[82.75rem] mx-auto">
              <ul class="flex gap-x-2 w-max">
                <router-link
                  :to="'/mall/' + activeCategory + '/' + subCategory.categoryId"
                  v-for="subCategory in categoryList2"
                  :key="subCategory.categoryId"
                  class="main-subMenu"
                  :class="{
                    current: subCategory.categoryId == route.params.subcategory,
                  }"
                >
                  {{ subCategory.categoryName }}
                </router-link>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </div>

    <!-- 홈 -->
    <div
      v-if="$route.path === '/mall' && !searched"
      class="max-w-[82.75rem] mx-auto"
    >
      <!-- 슬라이드 -->
      <div class="slide_wr rounded-[1.5rem] overflow-hidden">
        <!-- pagination="true" loop="true" -->
        <swiper-container
          navigation="true"
          autoplay-delay="4000"
          speed="800"
          effect="fade"
        >
          <swiper-slide>
            <img src="@/assets/img/main_confImg_hana2.jpg" alt="" />
          </swiper-slide>
          <swiper-slide>
            <img src="@/assets/img/main_confImg_hana.jpg" alt="" />
          </swiper-slide>
          <!-- <swiper-slide>
            <img src="@/assets/img/main_confImg.jpg" alt="" />
          </swiper-slide> -->
        </swiper-container>
      </div>

      <section class="mall_section">
        <h3 class="flex gap-2 font-bold items-center mb-6">
          신규 콘텐츠
          <svg
            width="42"
            height="20"
            viewBox="0 0 42 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="42" height="20" rx="10" fill="#FFA800" />
            <path
              d="M14.7578 5.51562V14H13.3984L9.37891 8.19922H9.30859V14H7.78516V5.51562H9.16797L13.1641 11.3164H13.2461V5.51562H14.7578ZM16.3281 14V5.51562H21.8477V6.79297H17.8516V9.11328H21.5547V10.3906H17.8516V12.7109H21.8711V14H16.3281ZM25.1055 14L22.7148 5.51562H24.3555L25.8906 11.7617H25.9727L27.6016 5.51562H29.1016L30.7422 11.7734H30.8125L32.3477 5.51562H33.9883L31.5977 14H30.0859L28.3867 8.03516H28.3281L26.6172 14H25.1055Z"
              fill="white"
            />
          </svg>
        </h3>
        <!-- 상품 그리드 -->
        <menu class="product_grid_container">
          <li
            v-if="loading === false"
            v-for="content in featuredItemList"
            :key="content.itemId"
            class="product_grid_wr"
          >
            <!-- 상품 thumb -->
            <div class="product_thumb mb-2">
              <router-link :to="'/mall/view/' + content.itemId">
                <img
                  v-if="content.thumbnailLink"
                  :src="
                    'https://eduwind-api.nodeblack.net/' + content.thumbnailLink
                  "
                  :alt="content.title"
                />
                <img
                  v-else
                  src="@/assets/img/null_img.jpg"
                  :alt="content.title"
                />
              </router-link>
              <!-- thumb 마우스오버 레이어 -->
              <div></div>
              <span>
                <!-- 장바구니 -->
                <button
                  @click="addCart(content.itemId)"
                  class="block w-fit h-fit"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="23"
                    viewBox="0 0 25 23"
                    fill="none"
                  >
                    <path
                      d="M4.06672 0.9H4.06669H1.76667C1.53752 0.9 1.31732 0.989031 1.15462 1.14819C0.991857 1.30741 0.9 1.52385 0.9 1.75C0.9 1.97615 0.991857 2.19259 1.15462 2.35181C1.31732 2.51097 1.53752 2.6 1.76667 2.6H3.39103L6.29282 13.9562C6.29282 13.9562 6.29283 13.9562 6.29283 13.9563C6.33985 14.1407 6.44844 14.3039 6.6008 14.4204C6.75314 14.5369 6.9406 14.5999 7.13336 14.6H7.13339H20.9335C21.1263 14.5999 21.3138 14.5369 21.4661 14.4204C21.6185 14.3039 21.7271 14.1406 21.7741 13.9562L24.0741 4.95626L24.0741 4.95621C24.1061 4.83064 24.1085 4.69955 24.081 4.57294C24.0535 4.44634 23.9969 4.32769 23.9157 4.22597C23.8345 4.12425 23.7308 4.04215 23.6127 3.98574C23.4945 3.92933 23.3649 3.90004 23.2336 3.9H5.50904L4.90727 1.54379C4.90727 1.54379 4.90727 1.54378 4.90726 1.54378C4.90726 1.54377 4.90726 1.54376 4.90726 1.54375C4.86023 1.35936 4.75165 1.19607 4.59929 1.07959C4.44695 0.963136 4.25948 0.900052 4.06672 0.9ZM7.80905 12.9L5.94348 5.6H22.1234L20.2579 12.9H7.80905ZM7.65243 18.0108C7.92107 17.748 8.28589 17.6 8.66674 17.6C9.04759 17.6 9.4124 17.748 9.68105 18.0108C9.94962 18.2736 10.1001 18.6294 10.1001 19C10.1001 19.3706 9.94962 19.7264 9.68105 19.9892C9.4124 20.252 9.04759 20.4 8.66674 20.4C8.28589 20.4 7.92107 20.252 7.65243 19.9892C7.38386 19.7264 7.23339 19.3706 7.23339 19C7.23339 18.6294 7.38386 18.2736 7.65243 18.0108ZM6.42833 16.8072C5.83422 17.3884 5.50004 18.1771 5.50004 19C5.50004 19.8229 5.83422 20.6116 6.42833 21.1928C7.02236 21.7739 7.82758 22.1 8.66674 22.1C9.5059 22.1 10.3111 21.7739 10.9051 21.1928C11.4993 20.6116 11.8334 19.8229 11.8334 19C11.8334 18.1771 11.4993 17.3884 10.9051 16.8072C10.3111 16.2261 9.5059 15.9 8.66674 15.9C7.82758 15.9 7.02236 16.2261 6.42833 16.8072ZM18.3859 18.0108C18.6545 17.748 19.0193 17.6 19.4002 17.6C19.781 17.6 20.1458 17.748 20.4145 18.0108C20.6831 18.2736 20.8335 18.6294 20.8335 19C20.8335 19.3706 20.6831 19.7264 20.4145 19.9892C20.1458 20.252 19.781 20.4 19.4002 20.4C19.0193 20.4 18.6545 20.252 18.3859 19.9892C18.1173 19.7264 17.9668 19.3706 17.9668 19C17.9668 18.6294 18.1173 18.2736 18.3859 18.0108ZM17.1618 16.8072C16.5677 17.3884 16.2335 18.1771 16.2335 19C16.2335 19.8229 16.5677 20.6116 17.1618 21.1928C17.7558 21.7739 18.561 22.1 19.4002 22.1C20.2393 22.1 21.0445 21.7739 21.6386 21.1928C22.2327 20.6116 22.5669 19.8229 22.5669 19C22.5669 18.1771 22.2327 17.3884 21.6386 16.8072C21.0445 16.2261 20.2393 15.9 19.4002 15.9C18.561 15.9 17.7558 16.2261 17.1618 16.8072Z"
                      fill="white"
                      stroke="white"
                      stroke-width="0.2"
                    />
                  </svg>
                </button>
                <!-- 다운로드 -->
                <!-- <button>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <path d="M10 15.5L3.75 9.25L5.5 7.4375L8.75 10.6875V0.5H11.25V10.6875L14.5 7.4375L16.25 9.25L10 15.5ZM2.5 20.5C1.8125 20.5 1.22375 20.255 0.733752 19.765C0.243752 19.275 -0.000831211 18.6867 2.12224e-06 18V14.25H2.5V18H17.5V14.25H20V18C20 18.6875 19.755 19.2762 19.265 19.7662C18.775 20.2562 18.1867 20.5008 17.5 20.5H2.5Z" fill="white"/>
                  </svg>
                </button> -->
              </span>
            </div>

            <!-- 상품설명 -->
            <div class="product_desc">
              <div class="flex gap-1">
                <span
                  v-for="tag in content.tagList"
                  :key="tag.tagId"
                  class="product_sub_tt"
                  >{{ tag }}</span
                >
              </div>

              <router-link
                :to="'/mall/view/' + content.itemId"
                class="product_tt mb-2"
              >
                {{ content.title }}
              </router-link>

              <div v-if="content.free === false">
                <div
                  v-if="content.regularPrice === content.sellingPrice"
                  class="flex gap-1 product_price"
                >
                  {{ content.sellingPrice.toLocaleString() }}원
                </div>
                <div v-else class="flex gap-1 product_price">
                  <strong>{{ content.discountRate.toLocaleString() }}%</strong>
                  {{ content.sellingPrice.toLocaleString() }}원
                  <p>{{ content.regularPrice.toLocaleString() }}원</p>
                </div>
              </div>
              <div v-else>
                <b>무료</b>
              </div>

              <div class="product_tags mt-2">
                <span v-if="content.itemKind && content.itemKind.length > 0">
                  {{ content.itemKind }}
                </span>
              </div>
            </div>
          </li>
        </menu>
      </section>

      <section>
        <h3 class="font-bold text-center pt-10">용품·교재 판매처</h3>
        <div class="flex gap-2 mx-auto mt-6 justify-center max-lg:flex-col">
          <a href="">
            <img
              src="@/assets/img/mallMain_link1.png"
              alt="총회교육몰 바로가기"
              class="mx-auto"
            />
          </a>
          <a href="">
            <img
              src="@/assets/img/mallMain_link2.png"
              alt="홀리원북 바로가기"
              class="mx-auto"
            />
          </a>
        </div>
      </section>
    </div>

    <!-- 상품목록 -->
    <div
      v-else
      class="mall_cate_container max-w-[82.75rem] mx-auto"
      :class="{ 'mt-14': route.params.category || route.params.subcategory }"
    >
      <div class="w-full flex flex-col">
        <!-- <div class="flex gap-4 bg-neutral-100 p-6 mb-10 text-sm">
          <label>
            <input type="checkbox"/> 3과정 2학기
          </label>
          <label>
            <input type="checkbox"/> 3과정 1학기
          </label>
        </div> -->

        <!--
        <div class="text-sm" v-if="!searched">
          <div class="bg-neutral-100 border border-neutral-200 p-4 mt-2">
            <div class="lg:flex items-center">
              <span class="w-20">기간조회</span>
              <VDatePicker v-model.range="range" locale="ko" :max-date='new Date()'>
                <template #default="{ inputValue, inputEvents }">
                  <div class="flex justify-center items-center">
                    <input type="text" class="regi_inputs w-full" :value="inputValue.start" v-on="inputEvents.start" />
                    <span class="mx-2">~</span>
                    <input type="text" class="regi_inputs w-full" :value="inputValue.end" v-on="inputEvents.end" />
                    
                    <button class="ml-2 sec_filled-blk_btn p-2 flex-1" type="button" @click="getContentsList">조회</button>
                  </div>
                </template>
              </VDatePicker>
            </div>
          </div>
        </div>
        -->

        <div
          class="flex items-center justify-between py-6 max-lg:px-5 max-md:items-start"
        >
          <div class="flex items-center gap-x-2 max-md:items-start">
            <div class="flex items-center gap-x-2">
              <div class="relative">
                <button
                  @click="isPopoverOpen = !isPopoverOpen"
                  class="flex items-center gap-x-2 border border-neutral-200 px-3 py-1.5 rounded text-sm hover:bg-neutral-50"
                >
                  {{
                    selectedCategory
                      ? selectedOption
                        ? `${getCategoryLabel(
                            selectedCategory
                          )} - ${getOptionLabel(selectedOption)}`
                        : getCategoryLabel(selectedCategory)
                      : "상세 검색"
                  }}
                  <svg
                    width="10"
                    height="5"
                    viewBox="0 0 10 5"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    :class="{ 'rotate-180': isPopoverOpen }"
                  >
                    <path
                      d="M0 0.550314L5 5L10 0.550314L9.37279 0L5 3.89151L0.627209 0L0 0.550314Z"
                      fill="black"
                    />
                  </svg>
                </button>

                <div v-if="isPopoverOpen" class="popover_container">
                  <div class="relative py-1 flex w-full">
                    <button
                      @click="isPopoverOpen = false"
                      class="absolute right-1 top-1 p-1"
                    >
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.59966 5.9976L11.1021 1.4908C11.1815 1.41097 11.226 1.30292 11.226 1.19031C11.2259 1.0777 11.1812 0.969714 11.1017 0.889996C10.9425 0.731596 10.6621 0.730796 10.5013 0.890796L6.00006 5.3976L1.49726 0.889596C1.33726 0.731596 1.05686 0.732396 0.897657 0.890396C0.858142 0.929753 0.826861 0.976587 0.80564 1.02816C0.784419 1.07974 0.773683 1.13503 0.774057 1.1908C0.774057 1.3044 0.818057 1.4108 0.897657 1.4896L5.40006 5.9972L0.898057 10.5052C0.818611 10.5851 0.774121 10.6933 0.774346 10.806C0.774571 10.9188 0.819493 11.0268 0.899257 11.1064C0.976457 11.1828 1.08566 11.2268 1.19846 11.2268H1.20086C1.31406 11.2264 1.42326 11.182 1.49886 11.1048L6.00006 6.598L10.5029 11.106C10.5825 11.1852 10.6889 11.2292 10.8017 11.2292C10.8574 11.2293 10.9126 11.2183 10.9641 11.197C11.0156 11.1757 11.0625 11.1444 11.1019 11.105C11.1413 11.0656 11.1725 11.0188 11.1939 10.9673C11.2152 10.9158 11.2261 10.8605 11.2261 10.8048C11.2261 10.6916 11.1821 10.5848 11.1021 10.506L6.59966 5.9976Z"
                          fill="black"
                        />
                      </svg>
                    </button>
                    <!-- 카테고리 섹션 -->
                    <div class="flex-grow flex-shrink-0">
                      <div
                        class="px-4 py-2 text-sm font-medium text-neutral-700 border-b border-neutral-100"
                      >
                        대분류
                      </div>
                      <label
                        v-for="category in categories"
                        :key="category.value"
                        class="min-w-40 flex items-center px-4 py-2 text-sm hover:bg-neutral-50 cursor-pointer"
                      >
                        <input
                          type="radio"
                          :value="category.value"
                          v-model="selectedCategory"
                          class="mr-2"
                          @change="handleCategoryChange"
                        />
                        {{ category.label }}
                      </label>
                    </div>

                    <!-- 옵션 섹션 -->
                    <div
                      class="flex-grow flex-shrink-0"
                      v-if="selectedCategory"
                    >
                      <template v-if="selectedCategory">
                        <div
                          class="px-4 py-2 text-sm font-medium text-neutral-700 border-b border-neutral-100"
                        >
                          소분류
                        </div>
                        <div
                          class="max-h-[30vh] overflow-y-auto overflow-x-hidden"
                        >
                          <label
                            v-for="option in currentOptions"
                            :key="option.value"
                            class="min-w-40 flex items-center px-4 py-2 text-sm hover:bg-neutral-50 cursor-pointer"
                          >
                            <input
                              type="radio"
                              :value="option.value"
                              v-model="selectedOption"
                              class="mr-2"
                              @change="handleOptionChange"
                            />
                            {{ option.label }}
                          </label>
                        </div>
                      </template>
                    </div>
                  </div>

                  <div class="md:hidden">
                    <div
                      class="mb-4 px-4 py-2 text-sm font-medium text-neutral-700 border-y border-neutral-100"
                    >
                      가격
                    </div>
                    <div class="text-sm flex gap-2">
                      <label
                        class="w-[4.375rem] cursor-pointer flex items-center justify-center gap-x-1 border border-neutral-200 px-3 py-2 rounded-full text-sm transition-colors"
                        :class="{
                          '!border-[var(--main-navy)] text-[var(--main-navy)]':
                            freeChecked,
                        }"
                      >
                        <input
                          type="checkbox"
                          class="appearance-none hidden"
                          v-model="freeChecked"
                          @change="checkfree"
                        />
                        <svg
                          width="11"
                          height="8"
                          viewBox="0 0 11 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          v-if="freeChecked"
                          :class="{ 'text-[var(--main-navy)]': freeChecked }"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M10.6036 1.4369L4.77022 7.27024C4.57495 7.4655 4.25837 7.4655 4.06311 7.27024L0.56311 3.77024L1.27022 3.06313L4.41666 6.20958L9.89644 0.729797L10.6036 1.4369Z"
                            fill="currentColor"
                          />
                        </svg>

                        <span>무료</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="max-md:hidden text-sm flex gap-2">
                <label
                  class="w-[4.375rem] cursor-pointer flex items-center justify-center gap-x-1 border border-neutral-200 px-3 py-2 rounded-full text-sm transition-colors"
                  :class="{
                    '!border-[var(--main-navy)] text-[var(--main-navy)]':
                      freeChecked,
                  }"
                >
                  <input
                    type="checkbox"
                    class="appearance-none hidden"
                    v-model="freeChecked"
                    @change="checkfree"
                  />
                  <svg
                    width="11"
                    height="8"
                    viewBox="0 0 11 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    v-if="freeChecked"
                    :class="{ 'text-[var(--main-navy)]': freeChecked }"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.6036 1.4369L4.77022 7.27024C4.57495 7.4655 4.25837 7.4655 4.06311 7.27024L0.56311 3.77024L1.27022 3.06313L4.41666 6.20958L9.89644 0.729797L10.6036 1.4369Z"
                      fill="currentColor"
                    />
                  </svg>

                  <span>무료</span>
                </label>
              </div>

              <div class="text-sm text-gray-500">총 {{ pageInfo.total }}개</div>
            </div>
          </div>
          <select
            v-model="selectedSort"
            @change="getContentsList(route.params.category)"
            v-if="!searched"
            class="block border border-neutral-200 p-1 rounded text-sm"
          >
            <option value="latest">최신순</option>
            <option value="seller">판매순</option>
            <option value="price">가격낮은순</option>
          </select>

          <select
            v-model="selectedSort"
            @change="searchItemList()"
            v-else
            class="block border border-neutral-200 p-1 rounded text-sm max-xl:mr-6"
          >
            <option value="latest">최신순</option>
            <option value="seller">판매순</option>
            <option value="price">가격낮은순</option>
          </select>
        </div>

        <!-- 상품 그리드 -->
        <div v-if="loading === false">
          <menu v-if="itemList.length > 0" class="product_grid_container">
            <li
              v-for="content in itemList"
              :key="content.itemId"
              class="product_grid_wr"
              @mouseover="hoveredItem = content.itemId"
              @mouseleave="hoveredItem = null"
            >
              <!-- 상품 thumb -->
              <div class="product_thumb mb-2">
                <router-link :to="'/mall/view/' + content.itemId">
                  <img
                    v-if="content.thumbnailLink"
                    :src="
                      'https://eduwind-api.nodeblack.net/' +
                      content.thumbnailLink
                    "
                    :alt="content.title"
                  />
                  <img
                    v-else
                    src="@/assets/img/null_img.jpg"
                    :alt="content.title"
                  />
                </router-link>
                <!-- thumb 마우스오버 레이어 -->
                <div></div>
                <span>
                  <!-- 장바구니 -->
                  <button
                    @click="addCart(content.itemId)"
                    class="block w-fit h-fit"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="23"
                      viewBox="0 0 25 23"
                      fill="none"
                    >
                      <path
                        d="M4.06672 0.9H4.06669H1.76667C1.53752 0.9 1.31732 0.989031 1.15462 1.14819C0.991857 1.30741 0.9 1.52385 0.9 1.75C0.9 1.97615 0.991857 2.19259 1.15462 2.35181C1.31732 2.51097 1.53752 2.6 1.76667 2.6H3.39103L6.29282 13.9562C6.29282 13.9562 6.29283 13.9562 6.29283 13.9563C6.33985 14.1407 6.44844 14.3039 6.6008 14.4204C6.75314 14.5369 6.9406 14.5999 7.13336 14.6H7.13339H20.9335C21.1263 14.5999 21.3138 14.5369 21.4661 14.4204C21.6185 14.3039 21.7271 14.1406 21.7741 13.9562L24.0741 4.95626L24.0741 4.95621C24.1061 4.83064 24.1085 4.69955 24.081 4.57294C24.0535 4.44634 23.9969 4.32769 23.9157 4.22597C23.8345 4.12425 23.7308 4.04215 23.6127 3.98574C23.4945 3.92933 23.3649 3.90004 23.2336 3.9H5.50904L4.90727 1.54379C4.90727 1.54379 4.90727 1.54378 4.90726 1.54378C4.90726 1.54377 4.90726 1.54376 4.90726 1.54375C4.86023 1.35936 4.75165 1.19607 4.59929 1.07959C4.44695 0.963136 4.25948 0.900052 4.06672 0.9ZM7.80905 12.9L5.94348 5.6H22.1234L20.2579 12.9H7.80905ZM7.65243 18.0108C7.92107 17.748 8.28589 17.6 8.66674 17.6C9.04759 17.6 9.4124 17.748 9.68105 18.0108C9.94962 18.2736 10.1001 18.6294 10.1001 19C10.1001 19.3706 9.94962 19.7264 9.68105 19.9892C9.4124 20.252 9.04759 20.4 8.66674 20.4C8.28589 20.4 7.92107 20.252 7.65243 19.9892C7.38386 19.7264 7.23339 19.3706 7.23339 19C7.23339 18.6294 7.38386 18.2736 7.65243 18.0108ZM6.42833 16.8072C5.83422 17.3884 5.50004 18.1771 5.50004 19C5.50004 19.8229 5.83422 20.6116 6.42833 21.1928C7.02236 21.7739 7.82758 22.1 8.66674 22.1C9.5059 22.1 10.3111 21.7739 10.9051 21.1928C11.4993 20.6116 11.8334 19.8229 11.8334 19C11.8334 18.1771 11.4993 17.3884 10.9051 16.8072C10.3111 16.2261 9.5059 15.9 8.66674 15.9C7.82758 15.9 7.02236 16.2261 6.42833 16.8072ZM18.3859 18.0108C18.6545 17.748 19.0193 17.6 19.4002 17.6C19.781 17.6 20.1458 17.748 20.4145 18.0108C20.6831 18.2736 20.8335 18.6294 20.8335 19C20.8335 19.3706 20.6831 19.7264 20.4145 19.9892C20.1458 20.252 19.781 20.4 19.4002 20.4C19.0193 20.4 18.6545 20.252 18.3859 19.9892C18.1173 19.7264 17.9668 19.3706 17.9668 19C17.9668 18.6294 18.1173 18.2736 18.3859 18.0108ZM17.1618 16.8072C16.5677 17.3884 16.2335 18.1771 16.2335 19C16.2335 19.8229 16.5677 20.6116 17.1618 21.1928C17.7558 21.7739 18.561 22.1 19.4002 22.1C20.2393 22.1 21.0445 21.7739 21.6386 21.1928C22.2327 20.6116 22.5669 19.8229 22.5669 19C22.5669 18.1771 22.2327 17.3884 21.6386 16.8072C21.0445 16.2261 20.2393 15.9 19.4002 15.9C18.561 15.9 17.7558 16.2261 17.1618 16.8072Z"
                        fill="white"
                        stroke="white"
                        stroke-width="0.2"
                      />
                    </svg>
                  </button>
                  <!-- 다운로드 -->
                  <!-- <button>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                      <path d="M10 15.5L3.75 9.25L5.5 7.4375L8.75 10.6875V0.5H11.25V10.6875L14.5 7.4375L16.25 9.25L10 15.5ZM2.5 20.5C1.8125 20.5 1.22375 20.255 0.733752 19.765C0.243752 19.275 -0.000831211 18.6867 2.12224e-06 18V14.25H2.5V18H17.5V14.25H20V18C20 18.6875 19.755 19.2762 19.265 19.7662C18.775 20.2562 18.1867 20.5008 17.5 20.5H2.5Z" fill="white"/>
                    </svg>
                  </button> -->
                </span>
              </div>

              <!-- 상품설명 -->
              <div class="product_desc">
                <router-link
                  :to="'/mall/view/' + content.itemId"
                  class="product_tt"
                >
                  {{ content.title }}
                </router-link>

                <!-- 마우스오버 전 -->
                <div v-if="hoveredItem !== content.itemId" class="mt-2">
                  <div
                    v-if="content.free === false || content.sellingPrice > 0"
                  >
                    <div
                      v-if="content.regularPrice === content.sellingPrice"
                      class="flex gap-1 product_price"
                    >
                      {{ content.sellingPrice.toLocaleString() }}원
                    </div>
                    <div v-else class="flex gap-1 product_price">
                      <strong
                        >{{ content.discountRate.toLocaleString() }}%</strong
                      >
                      {{ content.sellingPrice.toLocaleString() }}원
                      <p>{{ content.regularPrice.toLocaleString() }}원</p>
                    </div>
                  </div>
                  <div v-else>무료</div>

                  <div class="product_tags mt-2">
                    <span
                      v-if="content.itemKind && content.itemKind.length > 0"
                    >
                      {{ content.itemKind }}
                    </span>
                  </div>
                </div>

                <!-- 마우스오버 후 -->
                <div v-else class="mt-2">
                  <div class="flex items-center gap-x-1 flex-wrap mt-2">
                    <span
                      v-for="(tag, idx) in content.tagList"
                      :key="tag.tagId"
                      class="product_sub_tt leading-tight"
                    >
                      {{ tag
                      }}<span v-if="idx < content.tagList.length - 1">,</span>
                    </span>
                  </div>

                  <div class="flex items-center gap-x-3 text-neutral-700 mt-2">
                    <!-- 조회수 -->
                    <span class="flex items-center gap-x-1 leading-none">
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7 3.57143C6.2086 3.57143 5.56704 4.21102 5.56704 5C5.56704 5.78898 6.2086 6.42857 7 6.42857C7.7914 6.42857 8.43296 5.78898 8.43296 5C8.43296 4.21102 7.7914 3.57143 7 3.57143ZM4.13408 5C4.13408 3.42204 5.4172 2.14286 7 2.14286C8.5828 2.14286 9.86592 3.42204 9.86592 5C9.86592 6.57796 8.5828 7.85714 7 7.85714C5.4172 7.85714 4.13408 6.57796 4.13408 5Z"
                          fill="currentColor"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M3.88977 2.59447C2.94479 3.27223 2.17404 4.10263 1.68669 4.69247C1.61526 4.7791 1.56194 4.84383 1.51768 4.90085C1.4826 4.94604 1.46027 4.97748 1.4457 5C1.46027 5.02252 1.4826 5.05396 1.51768 5.09915C1.56194 5.15617 1.61526 5.2209 1.68669 5.30753C2.17404 5.89738 2.94479 6.72777 3.88977 7.40553C4.84051 8.08744 5.90668 8.57143 7 8.57143C8.09332 8.57143 9.15949 8.08744 10.1102 7.40553C11.055 6.72789 11.8257 5.89767 12.3131 5.30784C12.3846 5.22106 12.438 5.15624 12.4823 5.09915C12.5174 5.05396 12.5397 5.02252 12.5543 5C12.5397 4.97748 12.5174 4.94604 12.4823 4.90085C12.438 4.84376 12.3846 4.77894 12.3131 4.69216C11.8257 4.10233 11.055 3.27211 10.1102 2.59447C9.15949 1.91256 8.09332 1.42857 7 1.42857C5.90668 1.42857 4.84051 1.91256 3.88977 2.59447ZM3.05292 1.43482C4.1298 0.662441 5.4882 0 7 0C8.5118 0 9.8702 0.662441 10.9471 1.43482C12.0296 2.21125 12.8895 3.14288 13.4196 3.78445L13.42 3.78499C13.4371 3.80574 13.455 3.82709 13.4733 3.84907C13.6973 4.11693 14 4.47891 14 5C14 5.52109 13.6973 5.88306 13.4734 6.15093C13.455 6.17291 13.4371 6.19426 13.42 6.21501L13.4196 6.21555C12.8895 6.85712 12.0296 7.78875 10.9471 8.56518C9.8702 9.33756 8.5118 10 7 10C5.4882 10 4.1298 9.33756 3.05292 8.56518C1.97038 7.78875 1.1105 6.85712 0.580435 6.21555L0.579992 6.21501C0.562882 6.19426 0.545032 6.17292 0.526651 6.15093C0.302671 5.88307 0 5.52109 0 5C0 4.47891 0.30267 4.11694 0.526651 3.84907C0.545032 3.82709 0.562882 3.80574 0.579992 3.78499L0.580435 3.78445C1.1105 3.14288 1.97038 2.21125 3.05292 1.43482Z"
                          fill="currentColor"
                        />
                      </svg>
                      {{ content.viewCount }}
                    </span>

                    <!-- 다운로드 수 -->
                    <span class="flex items-center gap-x-1 leading-none">
                      <svg
                        width="14"
                        height="12"
                        viewBox="0 0 14 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M3.5 12C2.57174 12 1.6815 11.6488 1.02513 11.0237C0.368749 10.3986 0 9.55072 0 8.66667V6.66667C0 6.48986 0.0737497 6.32029 0.205025 6.19526C0.336301 6.07024 0.514348 6 0.7 6C0.885652 6 1.0637 6.07024 1.19497 6.19526C1.32625 6.32029 1.4 6.48986 1.4 6.66667V8.66667C1.4 9.1971 1.62125 9.70581 2.01508 10.0809C2.4089 10.456 2.94305 10.6667 3.5 10.6667H10.5C11.057 10.6667 11.5911 10.456 11.9849 10.0809C12.3788 9.70581 12.6 9.1971 12.6 8.66667V6.66667C12.6 6.48986 12.6737 6.32029 12.805 6.19526C12.9363 6.07024 13.1143 6 13.3 6C13.4857 6 13.6637 6.07024 13.795 6.19526C13.9263 6.32029 14 6.48986 14 6.66667V8.66667C14 9.55072 13.6313 10.3986 12.9749 11.0237C12.3185 11.6488 11.4283 12 10.5 12H3.5Z"
                          fill="currentColor"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M11.0005 4.6C11.0649 4.66261 11.1156 4.73669 11.1499 4.81801C11.1842 4.89932 11.2013 4.98627 11.2002 5.07388C11.1992 5.16149 11.18 5.24805 11.1438 5.3286C11.1076 5.40915 11.0551 5.48212 10.9893 5.54333L7.8393 8.47667C7.70851 8.59842 7.53289 8.66659 7.35 8.66659C7.16711 8.66659 6.99149 8.59842 6.8607 8.47667L3.7107 5.54333C3.64356 5.48245 3.58979 5.40948 3.55251 5.32865C3.51522 5.24781 3.49517 5.16073 3.49351 5.07246C3.49185 4.98419 3.50862 4.89648 3.54284 4.81442C3.57706 4.73237 3.62805 4.65761 3.69285 4.59448C3.75766 4.53135 3.83498 4.4811 3.92034 4.44666C4.0057 4.41223 4.09739 4.39428 4.19009 4.39386C4.2828 4.39344 4.37466 4.41057 4.46036 4.44424C4.54605 4.47791 4.62387 4.52745 4.6893 4.59L6.65 6.416V0.666667C6.65 0.489856 6.72375 0.320287 6.85503 0.195262C6.9863 0.070238 7.16435 0 7.35 0C7.53565 0 7.7137 0.070238 7.84498 0.195262C7.97625 0.320287 8.05 0.489856 8.05 0.666667V6.416L10.01 4.59C10.0757 4.52871 10.1535 4.48036 10.2389 4.44773C10.3243 4.41509 10.4156 4.3988 10.5076 4.39979C10.5996 4.40078 10.6905 4.41903 10.775 4.4535C10.8596 4.48797 10.9362 4.53731 11.0005 4.6Z"
                          fill="currentColor"
                        />
                      </svg>
                      {{ content.userDownloadCount }}
                    </span>
                  </div>
                </div>
              </div>
            </li>
          </menu>

          <menu v-else>
            <div class="text-center mt-14 pb-10" v-if="route.query.search">
              <h3 class="font-bold mb-5">검색 결과가 없습니다.</h3>
              <p class="leading-tight font-light">
                다른 검색어를 입력하시거나<br />철자와 띄어쓰기를 확인해보세요.
              </p>
            </div>

            <h3 class="font-bold text-center" v-else>목록이 없습니다.</h3>

            <section class="mall_section">
              <h3 class="flex gap-2 font-bold items-center mb-6">
                신규 콘텐츠
                <svg
                  width="42"
                  height="20"
                  viewBox="0 0 42 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="42" height="20" rx="10" fill="#FFA800" />
                  <path
                    d="M14.7578 5.51562V14H13.3984L9.37891 8.19922H9.30859V14H7.78516V5.51562H9.16797L13.1641 11.3164H13.2461V5.51562H14.7578ZM16.3281 14V5.51562H21.8477V6.79297H17.8516V9.11328H21.5547V10.3906H17.8516V12.7109H21.8711V14H16.3281ZM25.1055 14L22.7148 5.51562H24.3555L25.8906 11.7617H25.9727L27.6016 5.51562H29.1016L30.7422 11.7734H30.8125L32.3477 5.51562H33.9883L31.5977 14H30.0859L28.3867 8.03516H28.3281L26.6172 14H25.1055Z"
                    fill="white"
                  />
                </svg>
              </h3>
              <!-- 상품 그리드 -->
              <menu class="product_grid_container">
                <li
                  v-for="content in featuredItemList"
                  :key="content.itemId"
                  class="product_grid_wr"
                >
                  <!-- 상품 thumb -->
                  <div class="product_thumb mb-2">
                    <router-link :to="'/mall/view/' + content.itemId">
                      <img
                        v-if="content.thumbnailLink"
                        :src="
                          'https://eduwind-api.nodeblack.net/' +
                          content.thumbnailLink
                        "
                        :alt="content.title"
                      />
                      <img
                        v-else
                        src="@/assets/img/null_img.jpg"
                        :alt="content.title"
                      />
                    </router-link>
                    <!-- thumb 마우스오버 레이어 -->
                    <div></div>
                    <span>
                      <!-- 장바구니 -->
                      <button
                        @click="addCart(content.itemId)"
                        class="block w-fit h-fit"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="23"
                          viewBox="0 0 25 23"
                          fill="none"
                        >
                          <path
                            d="M4.06672 0.9H4.06669H1.76667C1.53752 0.9 1.31732 0.989031 1.15462 1.14819C0.991857 1.30741 0.9 1.52385 0.9 1.75C0.9 1.97615 0.991857 2.19259 1.15462 2.35181C1.31732 2.51097 1.53752 2.6 1.76667 2.6H3.39103L6.29282 13.9562C6.29282 13.9562 6.29283 13.9562 6.29283 13.9563C6.33985 14.1407 6.44844 14.3039 6.6008 14.4204C6.75314 14.5369 6.9406 14.5999 7.13336 14.6H7.13339H20.9335C21.1263 14.5999 21.3138 14.5369 21.4661 14.4204C21.6185 14.3039 21.7271 14.1406 21.7741 13.9562L24.0741 4.95626L24.0741 4.95621C24.1061 4.83064 24.1085 4.69955 24.081 4.57294C24.0535 4.44634 23.9969 4.32769 23.9157 4.22597C23.8345 4.12425 23.7308 4.04215 23.6127 3.98574C23.4945 3.92933 23.3649 3.90004 23.2336 3.9H5.50904L4.90727 1.54379C4.90727 1.54379 4.90727 1.54378 4.90726 1.54378C4.90726 1.54377 4.90726 1.54376 4.90726 1.54375C4.86023 1.35936 4.75165 1.19607 4.59929 1.07959C4.44695 0.963136 4.25948 0.900052 4.06672 0.9ZM7.80905 12.9L5.94348 5.6H22.1234L20.2579 12.9H7.80905ZM7.65243 18.0108C7.92107 17.748 8.28589 17.6 8.66674 17.6C9.04759 17.6 9.4124 17.748 9.68105 18.0108C9.94962 18.2736 10.1001 18.6294 10.1001 19C10.1001 19.3706 9.94962 19.7264 9.68105 19.9892C9.4124 20.252 9.04759 20.4 8.66674 20.4C8.28589 20.4 7.92107 20.252 7.65243 19.9892C7.38386 19.7264 7.23339 19.3706 7.23339 19C7.23339 18.6294 7.38386 18.2736 7.65243 18.0108ZM6.42833 16.8072C5.83422 17.3884 5.50004 18.1771 5.50004 19C5.50004 19.8229 5.83422 20.6116 6.42833 21.1928C7.02236 21.7739 7.82758 22.1 8.66674 22.1C9.5059 22.1 10.3111 21.7739 10.9051 21.1928C11.4993 20.6116 11.8334 19.8229 11.8334 19C11.8334 18.1771 11.4993 17.3884 10.9051 16.8072C10.3111 16.2261 9.5059 15.9 8.66674 15.9C7.82758 15.9 7.02236 16.2261 6.42833 16.8072ZM18.3859 18.0108C18.6545 17.748 19.0193 17.6 19.4002 17.6C19.781 17.6 20.1458 17.748 20.4145 18.0108C20.6831 18.2736 20.8335 18.6294 20.8335 19C20.8335 19.3706 20.6831 19.7264 20.4145 19.9892C20.1458 20.252 19.781 20.4 19.4002 20.4C19.0193 20.4 18.6545 20.252 18.3859 19.9892C18.1173 19.7264 17.9668 19.3706 17.9668 19C17.9668 18.6294 18.1173 18.2736 18.3859 18.0108ZM17.1618 16.8072C16.5677 17.3884 16.2335 18.1771 16.2335 19C16.2335 19.8229 16.5677 20.6116 17.1618 21.1928C17.7558 21.7739 18.561 22.1 19.4002 22.1C20.2393 22.1 21.0445 21.7739 21.6386 21.1928C22.2327 20.6116 22.5669 19.8229 22.5669 19C22.5669 18.1771 22.2327 17.3884 21.6386 16.8072C21.0445 16.2261 20.2393 15.9 19.4002 15.9C18.561 15.9 17.7558 16.2261 17.1618 16.8072Z"
                            fill="white"
                            stroke="white"
                            stroke-width="0.2"
                          />
                        </svg>
                      </button>
                      <!-- 다운로드 -->
                      <!-- <button>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                          <path d="M10 15.5L3.75 9.25L5.5 7.4375L8.75 10.6875V0.5H11.25V10.6875L14.5 7.4375L16.25 9.25L10 15.5ZM2.5 20.5C1.8125 20.5 1.22375 20.255 0.733752 19.765C0.243752 19.275 -0.000831211 18.6867 2.12224e-06 18V14.25H2.5V18H17.5V14.25H20V18C20 18.6875 19.755 19.2762 19.265 19.7662C18.775 20.2562 18.1867 20.5008 17.5 20.5H2.5Z" fill="white"/>
                        </svg>
                      </button> -->
                    </span>
                  </div>

                  <!-- 상품설명 -->
                  <div class="product_desc">
                    <div class="flex gap-1">
                      <span
                        v-for="tag in content.tagList"
                        :key="tag.tagId"
                        class="product_sub_tt"
                        >{{ tag }}</span
                      >
                    </div>

                    <router-link
                      :to="'/mall/view/' + content.itemId"
                      class="product_tt mb-2"
                    >
                      {{ content.title }}
                    </router-link>

                    <div v-if="content.free === false">
                      <div
                        v-if="content.regularPrice === content.sellingPrice"
                        class="flex gap-1 product_price"
                      >
                        {{ content.sellingPrice.toLocaleString() }}원
                      </div>
                      <div v-else class="flex gap-1 product_price">
                        <strong
                          >{{ content.discountRate.toLocaleString() }}%</strong
                        >
                        {{ content.sellingPrice.toLocaleString() }}원
                        <p>{{ content.regularPrice.toLocaleString() }}원</p>
                      </div>
                    </div>
                    <div v-else>
                      <b>무료</b>
                    </div>

                    <div class="product_tags mt-2">
                      <span
                        v-if="content.itemKind && content.itemKind.length > 0"
                      >
                        {{ content.itemKind }}
                      </span>
                    </div>
                  </div>
                </li>
              </menu>
            </section>
          </menu>

          <pagination
            v-if="pageInfo.page"
            :pageInfo="pageInfo"
            :page="getPage"
            :size="size"
            @updatePage="updatePage"
          />
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
import {
  onMounted,
  ref,
  watchEffect,
  computed,
  defineProps,
  onUnmounted,
} from "vue";
import { optionsMap } from "@/assets/js/optionsConfig.js";
import axios from "axios";
import router from "@/router";
import { useRoute } from "vue-router";
const route = useRoute();

// props 정의
const props = defineProps({
  searchQuery: {
    type: String,
    default: "",
  },
});

import Pagination from "@/components/Pagination.vue";
import { editCart } from "@/assets/js/cart.js";

const categoryList = ref([]);
const categoryList2 = ref([]);
const activeCategory = ref(null);
const subCategoriesMap = ref(new Map()); // 서브카테고리 데이터를 저장할 Map 추가
const lastHoveredCategory = ref(null); // 마지막 카테고리 ID를 저장

const loading = ref(true);

const itemList = ref([]);
const featuredItemList = ref([]); // 신규 콘텐츠용 별도 리스트

const start = new Date();
const end = new Date();
start.setDate(end.getDate() - 90);

// 상품 검색 및 정렬
const searchQuery = ref("");
const selectedSort = ref("latest");
const selectedCategoryId = ref("");
const searched = ref(false);
const pageUnitSize = 5;

// const category = route.params.category;

// 카테고리 리스트
// const getCategoryList = async (parentId = null) => {
//   try {
//     const res = await axios.get(
//       `/new_api/category/list/simple${parentId ? `?parentId=${parentId}` : ""}`
//     );
//     if (parentId) {
//       categoryList2.value = res.data.data.categoryList;
//     } else {
//       categoryList.value = res.data.data.categoryList;
//     }
//   } catch (error) {
//     console.error(error);
//   } finally {
//     searched.value = false;
//   }
// };
const getCategoryList = async () => {
  try {
    const res = await axios.get("/new_api/category/list");
    categoryList.value = res.data.data.categoryList;
  } catch (error) {
    console.error(error);
  }
};

// 신규 콘텐츠 리스트 가져오기
const getFeaturedContentsList = async () => {
  try {
    const apiUrl = `/new_api/customer/item/list?page=1&size=5&prop=latest&itemType=CONTENT`;
    const { data } = await axios.get(apiUrl);
    featuredItemList.value = data.data.itemList || [];
  } catch (error) {
    console.error("Featured content fetch error:", error);
    featuredItemList.value = [];
  }
};

const getSubCategories = async (parentId) => {
  try {
    if (!parentId) return;
    if (lastHoveredCategory.value === parentId) {
      return;
    }
    lastHoveredCategory.value = parentId;

    // 이미 저장된 서브카테고리가 있는지 확인
    if (subCategoriesMap.value.has(parentId)) {
      categoryList2.value = subCategoriesMap.value.get(parentId);
      activeCategory.value = parentId;
      return;
    }

    const res = await axios.get(
      `/new_api/category/list/simple?parentId=${parentId}`
    );
    const subCategories = res.data.data.categoryList;

    // 서브카테고리 데이터를 Map에 저장
    subCategoriesMap.value.set(parentId, subCategories);
    categoryList2.value = subCategories;
    activeCategory.value = parentId;
  } catch (err) {
    console.error(err);
  }
};

const hideSubCategories = () => {
  lastHoveredCategory.value = null; // 마우스가 떠날 때 lastHoveredCategory 초기화
  if (!route.params.category && !route.params.subcategory) {
    activeCategory.value = null;
    categoryList2.value = [];
  } else if (route.params.category) {
    if (subCategoriesMap.value.has(route.params.category)) {
      categoryList2.value = subCategoriesMap.value.get(route.params.category);
      activeCategory.value = route.params.category;
    }
  }
};

const selectedCategory = ref("");
const selectedOption = ref("");

const currentOptions = computed(() => optionsMap[selectedCategory.value]);

let pageInfo = ref({});
let getPage = ref(1);
let size = ref(15);

// 상품 리스트 get
const getContentsList = async (cateId) => {
  const page = getPage.value;
  cateId = cateId ?? (route.params.subcategory || route.params.category);
  const itemType = "CONTENT"; // 컨텐츠만 조회되도록 고정

  try {
    loading.value = true;
    let sortOrder = "";

    if (selectedSort.value === "price") {
      sortOrder = "asc";
    }

    let apiUrl = `/new_api/customer/item/list?page=${page}`;
    apiUrl += size.value ? `&size=${size.value}` : "";
    apiUrl += selectedSort.value ? `&prop=${selectedSort.value}` : "";
    apiUrl += sortOrder ? `&dir=${sortOrder}` : "";
    apiUrl += pageUnitSize ? `&pageUnitSize=${pageUnitSize}` : "";
    apiUrl += searchQuery.value ? `&title=${searchQuery.value}` : "";
    apiUrl += itemType ? `&itemType=${itemType}` : "";
    apiUrl += cateId ? `&categoryId=${cateId}` : "";
    apiUrl += freeChecked.value ? `&free=${freeChecked.value}` : "";
    if (selectedCategory.value && selectedOption.value) {
      apiUrl += `&${selectedCategory.value}=${selectedOption.value}`;
    }

    // apiUrl += ( formStartDate.value ) ? `&startDate=${formStartDate.value}`:'';
    // apiUrl += ( formEndDate.value ) ? `&endDate=${formEndDate.value}`:'';
    // `/new_api/customer/content/list?page=${page}&size=${size.value}&startDate=${formStartDate.value}&endDate=${formEndDate.value}&prop=${selectedSort.value}&dir=${sortOrder}&rootCategoryId=${cateId}`

    // console.log(apiUrl);

    const { data, status } = await axios.get(apiUrl);

    console.log(data);

    itemList.value = data.data.itemList;
    pageInfo.value = data.data.pageInfo;
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
    searched.value = false;
  }
};

const updatePage = (num) => {
  getPage.value = num;
  console.log(getPage.value);

  if (searched.value === true) {
    searchItemList();
  } else {
    getContentsList(route.params.subcategory || route.params.category);
  }
};

// 장바구니 추가
const addCart = (itemId) => {
  editCart(itemId, 1, true, "CREATE").then((res) => {
    console.log(res);
    if (res.data.code === "200") {
      alert("장바구니에 담겼습니다.");
      router.push({ name: "cart" }); // 장바구니 이동 여부 묻도록 변경할 것
    }
  });
};

// 상품 리스트 검색
const searchItemList = async (pageNum) => {
  let pageValue;

  if (pageNum) {
    pageValue = pageNum;
  } else {
    pageValue = getPage.value;
  }

  if (!searchQuery.value) {
    alert("검색어를 입력해 주세요.");
    return;
  }

  try {
    loading.value = true;
    let sortOrder = "";

    // 현재 라우트의 카테고리 ID를 가져옵니다
    const currentCategoryId = selectedCategoryId.value || route.params.category;

    // URL에 검색 쿼리 추가
    const queryParams = {
      ...route.query, // 기존 쿼리 파라미터 유지
      search: searchQuery.value,
    };

    if (currentCategoryId) {
      await router.push({
        path: `/mall/${currentCategoryId}`,
        query: queryParams,
      });
    } else {
      await router.push({
        path: "/mall/",
        query: queryParams,
      });
    }

    if (selectedSort.value === "price") {
      sortOrder = "asc";
    }

    let url = `/new_api/customer/item/list?page=${pageValue}`;
    url += size.value ? `&size=${size.value}` : "";
    url += selectedSort.value ? `&prop=${selectedSort.value}` : "";
    url += sortOrder ? `&dir=${sortOrder}` : "";
    url += pageUnitSize ? `&pageUnitSize=${pageUnitSize}` : "";
    url += currentCategoryId ? `&categoryId=${currentCategoryId}` : "";
    url += searchQuery.value ? `&title=${searchQuery.value}` : "";

    const res = await axios.get(url);
    itemList.value = res.data.data.itemList;
    pageInfo.value = res.data.data.pageInfo;
    searched.value = true; // 검색 상태로 설정
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};

const handleSearch = async (pageNum) => {
  await searchItemList(pageNum);
};

const hoveredItem = ref(null);

const isPopoverOpen = ref(false);
const categories = [
  { value: "groupName", label: "대상별" },
  { value: "contentType", label: "형태별" },
  { value: "solarTerm", label: "절기별" },
  { value: "bibleBookName", label: "성경별" },
  { value: "hanaDivision", label: "하나바이블" },
];

const getCategoryLabel = (value) => {
  const category = categories.find((c) => c.value === value);
  return category ? category.label : "";
};

const getOptionLabel = (value) => {
  if (!selectedCategory.value || !currentOptions.value) return "";
  const option = currentOptions.value.find((o) => o.value === value);
  return option ? option.label : "";
};

const handleCategoryChange = () => {
  selectedOption.value = "";

  // 검색어가 있을 때만 검색 실행
  if (searchQuery.value) {
    searchItemList();
  } else {
    // 검색어가 없을 때는 일반 목록 조회
    getContentsList(selectedCategoryId.value);
  }
};

const handleOptionChange = () => {
  isPopoverOpen.value = false;
  getContentsList(route.params.category);
};

const freeChecked = ref(false);
const checkfree = () => {
  getContentsList(route.params.category);
};

// 스크롤 관련 상태 관리
const lastScrollY = ref(0);
const shopTopMenuRef = ref(null);
const navHeight = ref(0);

// 스크롤 이벤트 핸들러
const handleScroll = () => {
  const currentScrollY = window.scrollY;
  const scrollDirection = currentScrollY > lastScrollY.value ? "down" : "up";

  // 위로 스크롤할 때만 처리
  if (scrollDirection === "up" && shopTopMenuRef.value) {
    // 위로 스크롤할 때: transition delay 추가
    shopTopMenuRef.value.style.transitionDelay = "0.25s";
    // nav_container의 높이만큼 top 값 설정
    shopTopMenuRef.value.style.top = `${navHeight.value}px`;
    shopTopMenuRef.value.style.transition = "top 1s";
    shopTopMenuRef.value.style.transitionDelay = "0.25s";
  } else if (scrollDirection === "down" && shopTopMenuRef.value) {
    // 아래로 스크롤할 때
    shopTopMenuRef.value.style.transition = "top 0.7s";
    shopTopMenuRef.value.style.transitionDelay = "0s";
    shopTopMenuRef.value.style.top = "0";
  }

  lastScrollY.value = currentScrollY;
};

// nav_container 높이 가져오기
const getNavHeight = () => {
  // CSS 변수에서 nav 높이 가져오기
  const navHeightVar = getComputedStyle(document.documentElement)
    .getPropertyValue("--nav-height")
    .trim();

  if (navHeightVar) {
    // 'px' 제거하고 숫자로 변환
    navHeight.value = parseInt(navHeightVar.replace("px", "")) || 80;
  } else {
    // 기본값 설정
    navHeight.value = 80;
  }
};

onMounted(async () => {
  console.log(getPage.value);

  // nav 높이 가져오기
  getNavHeight();

  // 스크롤 이벤트 리스너 추가
  window.addEventListener("scroll", handleScroll, { passive: true });

  await getCategoryList(route.params.category); // 카테고리 GET
  await getFeaturedContentsList(); // 신규 콘텐츠 GET

  // props로 받은 검색어나 라우트 쿼리에 검색어가 있으면 searchItemList 실행
  if (props.searchQuery || route.query.search) {
    searchQuery.value = props.searchQuery || route.query.search;
    await searchItemList();
  } else {
    await getContentsList(route.params.subcategory || route.params.category); // 상품목록 GET
  }

  await getSubCategories(route.params.category); // 서브 카테고리 GET
});

// 컴포넌트 언마운트 시 이벤트 리스너 제거
onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});

watchEffect(
  () => [itemList.value, categoryList.value, categoryList2.value],
  () => {
    loading.value = false;
  }
);

// route의 category 파라미터가 변경될 때 selectedCategoryId를 동기화
watchEffect(() => {
  if (route.params.category) {
    selectedCategoryId.value = route.params.category;
  }
});
</script>

<style>
.bg-black-alpha {
  background: rgba(0, 0, 0, 0.2);
}
</style>
